'use client'

import { useState } from 'react'
import { useScrollProgress } from '../../lib/use-scroll-progress'

const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']

/* Illustrative compliance moments across a license year. Structure,
   not statistics: cadences (quarterly reports, the Nov 1 to Dec 31
   renewal window) are public; no amounts or made-up dates. */
const MOMENTS: { month: number; label: string }[] = [
  { month: 0, label: 'Annual report season opens' },
  { month: 2, label: 'Quarterly call report' },
  { month: 4, label: 'Amendment filed for an address change' },
  { month: 5, label: 'Quarterly call report' },
  { month: 7, label: 'Exam readiness review' },
  { month: 8, label: 'Quarterly call report' },
  { month: 10, label: 'Renewal window opens November 1' },
  { month: 11, label: 'Renewals filed, the year closes' },
]

export function MaintainYear() {
  const [month, setMonth] = useState(0)
  const ref = useScrollProgress<HTMLElement>({
    onProgress: (p) => setMonth(Math.min(11, Math.floor(p * 12))),
  })

  return (
    <section
      ref={ref}
      className="pin-section pin-section-alt"
      style={{ height: '300vh' }}
    >
      <div className="pin-frame">
        <div className="year-inner">
          <p className="section-label">THE YEAR OF A LICENSE</p>
          <h2 className="subpage-heading">
            Twelve months of obligations, planned backward from every
            deadline.
          </h2>
          <div className="year-band" data-month={month}>
            {MONTHS.map((m, i) => (
              <div
                key={m}
                className={i <= month ? 'year-month passed' : 'year-month'}
              >
                <span className="year-month-label">{m}</span>
              </div>
            ))}
          </div>
          <ul className="year-moments">
            {MOMENTS.map((mo) => (
              <li
                key={`${mo.month}-${mo.label}`}
                className={
                  mo.month <= month ? 'year-moment passed' : 'year-moment'
                }
              >
                <span className="year-moment-month">{MONTHS[mo.month]}</span>
                {mo.label}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}
